import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
const useMobileCarousel = () => {
    const { t, i18n } = useTranslation();
    const ARR = useMemo(
        () => [
            {
                type: 'image',
                srcType: 'image', //srcType: 是我新增的屬性，需要檢查，其他地方有沒有ts的 interface需要補充
                src: '/leading/leadingPageAssets/images/hallway/AboutBBIN/AboutBBIN_Mobile.jpg',

                title: 'BBIN',
                subtitle: t('about-bbin-subtitle'),

                insideSrc:
                    '/leading/leadingPageAssets/images/hallway/AboutBBIN/About BBIN_1100x730.png',
                content: (
                    <>
                        {t('about-bbin-content-1')}
                        <br />
                        {t('about-bbin-content-2')}
                    </>
                )
            }
        ],
        [i18n.language, t]
    );
    const ARR_TWO = useMemo(
        () => [
            {
                type: 'youtube',

                srcType: 'image', //image, video
                src: '/leading/leadingPageAssets/images/hallway/year/2025.png',
                // src: '/leading/leadingPageAssets/videos/texture_chasing_excellence.mp4',

                title: '2025',
                subtitle: 'CHASING EXCELLENCE',

                insideSrc: 'https://www.youtube.com/embed/veIDxQ0uRJ8',
                content: <>{t('year-2025')}</>
            },
            {
                type: 'youtube',
                srcType: 'image', 
                src: '/leading/leadingPageAssets/images/hallway/year/2023.jpg',
                // src: '/leading/leadingPageAssets/videos/texture_go_better.mp4',

                title: '2023',
                subtitle: 'GO BETTER',

                insideSrc: i18n.language === 'en' ? 'https://www.youtube.com/embed/R81C3EeSl6M' : 'https://www.youtube.com/embed/8xF326FpQJg',
                content: <>{t('year-2023')}</>
            },
            {
                type: 'video',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/year/2022.jpg',
                // src: '/leading/leadingPageAssets/videos/texture_the_gaming_beat.mp4',

                title: '2022',
                subtitle: 'THE GAMING BEAT',

                insideSrc:
                    '/leading/leadingPageAssets/videos/texture_the_gaming_beat.mp4',
                content: <>{t('year-2022')}</>
            },
            {
                type: 'youtube',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/year/2021.jpg',
                // src: '/leading/leadingPageAssets/videos/texture_move_beyond_drive_change.mp4',

                title: '2021',
                subtitle: 'MOVE BEYOND DRIVE CHANGE',

                insideSrc: 'https://www.youtube.com/embed/c4YSUAxmvYk',
                content: <>{t('year-2021')}</>
            },
            {
                type: 'youtube',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/year/2020.jpg',
                // src: '/leading/leadingPageAssets/videos/texture_up.mp4',

                title: '2020',
                subtitle: 'UP',

                insideSrc: 'https://www.youtube.com/embed/bGNzurCbrNM',
                content: <>{t('year-2020')}</>
            }
        ],
        [i18n.language, t]
    );
    const ARR_THREE = useMemo(
        () => [
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/IGA/IGA_1100x730.jpg',

                title: 'IGA',
                subtitle: t('award-IGA-subtitle'),

                insideSrc: '/leading/leadingPageAssets/images/hallway/IGA/IGA_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        2025
                        <br />
                        {t('award-IGA-15')}
                        <br />
                        {t('award-IGA-16')}
                        <br />
                        {t('award-IGA-17')}
                        <br />
                        <br />
                        2024
                        <br />
                        {t('award-IGA-18')}
                        <br />
                        {t('award-IGA-19')}
                        <br />
                        {t('award-IGA-20')}
                        <br />
                        {t('award-IGA-21')}
                        <br />
                        {t('award-IGA-22')}
                        <br />
                        {t('award-IGA-23')}
                        <br />
                        <br />
                        2023
                        <br />
                        {t('award-IGA-1')}
                        <br />
                        {t('award-IGA-2')}
                        <br />
                        {t('award-IGA-3')}
                        <br />
                        {t('award-IGA-4')}
                        <br />
                        {t('award-IGA-5')}
                        <br />
                        {t('award-IGA-6')}
                        <br />
                        <br />
                        {t('award-IGA-7')}
                        <br />
                        {t('award-IGA-8')}
                        <br />
                        {t('award-IGA-9')}
                        <br />
                        {t('award-IGA-10')}
                        <br />
                        {t('award-IGA-11')}
                        <br />
                        <br />
                        2017
                        <br />
                        {t('award-IGA-12')}
                        <br />
                        {t('award-IGA-13')}
                        <br />
                        {t('award-IGA-14')}
                    </>
                )
            },
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/EGR/EGR_1100x730.jpg',

                title: 'EGR B2B',
                subtitle: t('award-EGR-subtitle'),

                insideSrc: '/leading/leadingPageAssets/images/hallway/EGR/EGR_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        2025
                        <br />
                        {t('award-EGR-16')}
                        <br />
                        <br />
                        2024
                        <br />
                        {t('award-EGR-17')}
                        <br />
                        <br />
                        2023
                        <br />
                        {t('award-EGR-1')}
                        <br />
                        {t('award-EGR-2')}
                        <br />
                        <br />
                        2022
                        <br />
                        {t('award-EGR-3')}
                        <br />
                        {t('award-EGR-4')}
                        <br />
                        <br />
                        2021
                        <br />
                        {t('award-EGR-5')}
                        <br />
                        {t('award-EGR-6')}
                        <br />
                        {t('award-EGR-7')}
                        <br />
                        <br />
                        2020
                        <br />
                        {t('award-EGR-8')}
                        <br />
                        {t('award-EGR-9')}
                        <br />
                        <br />
                        2019
                        <br />
                        {t('award-EGR-10')}
                        <br />
                        {t('award-EGR-11')}
                        <br />
                        <br />
                        2018
                        <br />
                        {t('award-EGR-12')}
                        <br />
                        {t('award-EGR-13')}
                        <br />
                        {t('award-EGR-14')}
                        <br />
                        <br />
                        2017
                        <br />
                        {t('award-EGR-15')}
                    </>
                )
            },
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/AGA/AGA_1100x730.jpg',

                title: 'AGA',
                subtitle: t('award-AGA-subtitle'),

                insideSrc: '/leading/leadingPageAssets/images/hallway/AGA/AGA_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        2023
                        <br />
                        {t('award-AGA-1')}
                        <br />
                        {t('award-AGA-2')}
                        <br />
                        {t('award-AGA-3')}
                        <br />
                        {t('award-AGA-4')}
                        <br />
                        <br />
                        2017
                        <br />
                        {t('award-AGA-5')}
                        <br />
                        <br />
                        2016
                        <br />
                        {t('award-AGA-6')}
                    </>
                )
            },
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/EuropeGamingAwards/Europe-Gaming-Awards_1100x730.jpg',

                title: 'Europe Gaming Awards',
                subtitle: t('award-EGA-subtitle'),

                insideSrc:
                    '/leading/leadingPageAssets/images/hallway/EuropeGamingAwards/Europe Gaming Awards_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        {t('award-EGA-3')}
                        <br />
                        {t('award-EGA-1')}
                        <br />
                        {t('award-EGA-2')}
                    </>
                )
            },
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/StarletAwards/Starlet-Awards_1100x730.jpg',

                title: 'Starlet Awards',
                subtitle: t('award-Star-subtitle'),

                insideSrc:
                    '/leading/leadingPageAssets/images/hallway/StarletAwards/Starlet Awards_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        {t('award-Star-1')}
                        <br />
                        {t('award-Star-2')}
                    </>
                )
            },
            {
                type: 'image',
                srcType: 'image',
                src: '/leading/leadingPageAssets/images/hallway/SPiCEPhilippines/SPiCE-Philippines_1100x730.jpg',
                title: 'SPiCE Philippines',
                subtitle: t('award-spice-subtitle'),

                insideSrc:
                    '/leading/leadingPageAssets/images/hallway/SPiCEPhilippines/SPiCE Philippines_1100x730.png',
                content: (
                    <>
                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {t('award-bbin')}
                        </span>
                        <br />
                        <br />
                        2022
                        <br />
                        {t('award-spice-1')}
                        <br />
                        {t('award-spice-2')}
                    </>
                )
            }
        ],
        [i18n.language, t]
    );

    return { ARR, ARR_TWO, ARR_THREE };
};

export default useMobileCarousel;
